import { t } from 'i18next';
import { Button } from '@peacecover/component';
import { ArrowLeft } from '@peacecover/icon';
import { useGetBettieBalances } from '../../domains/bettie/ui/hooks/useGetBettieBalances';
import { useEnterRedeemCode } from './hooks/useEnterRedeemCode';
import { useHandleHistoryBack } from '../../utils/useHandleHistoryBack';
import { ReactComponent as LikeGradientShape } from '../../icons/likeGradientShape.svg';
import { Trans } from 'react-i18next';

const EnterRedeemCodePage = () => {
  const { data: bettieBalances } = useGetBettieBalances();
  const handleHistoryBack = useHandleHistoryBack();
  const { inviteCode, handleChangeInviteCode, handleSpendInviteCode } = useEnterRedeemCode();

  return (
    <div className="min-h-screen pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] bg-background-light dark:bg-background-dark">
      <header className="px-[16px] py-[10px] flex items-center justify-between">
        <ArrowLeft size={24} className="text-text-main-lv1" onClick={handleHistoryBack} />
        <div className="flex items-center gap-[2px]">
          <LikeGradientShape width={20} height={20} />
          <p className="text-[16px] font-medium leading-[19px] text-text-main-lv1">
            {t('InviteFriends.heartCount', { count: bettieBalances?.bettiePoint?.balance ?? 0 })}
          </p>
        </div>
      </header>
      <div className="flex flex-col items-center px-[24px]">
        <div className="flex flex-col items-center mt-[30px]">
          <img
            src="/assets/icons/graphic-3d/3D.like.png"
            alt="like"
            className="w-[48px] h-[48px]"
          />
          <h1 className="text-[17px] font-bold leading-[20px] text-text-main-lv1 mt-[18px]">
            {t('EnterRedeemCode.title')}
          </h1>
          <p className="text-[15px] font-medium leading-[18px] text-text-main-lv4 text-center mt-[14px]">
            {t('EnterRedeemCode.checkRedeemCode')}
          </p>
        </div>
        <input
          type="text"
          placeholder={t('EnterRedeemCode.placeholder') ?? ''}
          value={inviteCode}
          onChange={handleChangeInviteCode}
          className="border border-separator2 px-[16px] py-[17px] bg-background-light dark:bg-background-dark rounded-[12px] mt-[38px] w-full text-[17px] font-semibold text-text-main-lv2 leading-[20px] focus:outline-none placeholder:text-placeholder-light dark:placeholder:text-placeholder-dark"
        />
        <div className="relative mt-[28px]">
          <div
            className="w-[204px] h-[50px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            style={{
              background:
                'radial-gradient(50% 50% at 50% 50%, rgba(255, 72, 166, 0.12) 0%, rgba(255, 72, 166, 0.00) 100%)',
              filter: 'blur(7.550000190734863px)'
            }}
          />
          <p className="text-[14px] font-medium leading-[17px] text-text-main-lv3 text-center whitespace-pre-line">
            <Trans
              i18nKey="EnterRedeemCode.description"
              components={{
                bold: <span className="font-bold" />,
                br: <br />
              }}
            />
          </p>
        </div>
      </div>
      <div className="fixed left-0 right-0 bottom-[calc(env(safe-area-inset-bottom)+10px)] px-[24px]">
        <Button
          size="large"
          className={`text-[17px] font-semibold w-full bg-gradient-to-r from-[#FF45A9] to-[#FF6A6A] text-pure-white ${inviteCode.length === 0 ? 'bg-disable text-on-disable' : ''}`}
          disabled={inviteCode.length === 0}
          onClick={handleSpendInviteCode}
        >
          {t('EnterRedeemCode.complete')}
        </Button>
      </div>
    </div>
  );
};

export default EnterRedeemCodePage;
